import React, { useEffect, createElement } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusSection } from './components/BonusSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1747467019720990');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1747467019720990&ev=PageView&noscript=1" alt="" data-id="element-1" />
      </noscript>
      <div className="min-h-screen bg-brand-ivory text-brand-text overflow-x-hidden flex flex-col items-center" data-id="element-2">
        <div className="w-full max-w-2xl bg-white shadow-2xl" data-id="element-3">
          <UrgencyBanner data-id="element-4" />
          <Hero data-id="element-5" />
          <PainSection data-id="element-6" />
          <SolutionSection data-id="element-7" />
          <BonusSection data-id="element-8" />
          <BenefitsSection data-id="element-9" />
          <PricingCard data-id="element-10" />
          <Guarantee data-id="element-11" />
          <Testimonials data-id="element-12" />
          <FAQ data-id="element-13" />
          <FinalCTA data-id="element-14" />
          <Footer data-id="element-15" />
        </div>
      </div>
    </>;
}